import { Form, Formik } from 'formik';
import InputText from '../../../components/input-text/inputText';
import ModalComponent from '../../../components/modal/modal';
import ModalBody from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import CustomTextArea from '../../../components/text-area/textArea';
import {
  usePostCommissionRateSchedule,
  usePostDepartment,
  usePostSecFee,
  useWealthlaneCustomerApi,
} from '../../../hooks';
import { type ModalStatusType } from '../../../types/common';
import {
  COMMISSION_VALIDATION,
  DEPARTMENT_VALIDATION,
  FEE_VALIDATION,
} from '../../../utils/validations/validations';
import _ from 'lodash';
import FormSelect from '../../../components/dropdown/formSelect';
import useGetBrokerOptions from '../../../hooks/get/useGetBrokerOptions';
import { CommaFormattedFloatPost } from '../../../utils/global';
import CustomDatePicker from '../../../components/date-picker/customDatePicker';
interface FeeModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  setModalStatus: (value: ModalStatusType) => void;
  initialData: {
    data: {
      effectiveDate: string;
      rate: string;
    };
    id: string;
  };
  loading: boolean;
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
  modalStatus: ModalStatusType;
  id?: string;
}

const FeeModal = ({
  isModalOpen,
  closeModal,
  initialData,
  setModalStatus,
  loading,
  handleRequest,
  modalStatus,
  id
}: FeeModalType): JSX.Element => {
  const { handleRequest: customerHandleRequest } = useWealthlaneCustomerApi();

  const { mutate, isLoading } = usePostSecFee(handleRequest, closeModal);

  return (
    <Formik
      enableReinitialize
      initialValues={initialData.data}
      validationSchema={FEE_VALIDATION}
      onSubmit={(values) => {
        const payload = {
          ...values,
          rate: values?.rate.replaceAll(',', ''),
        };
        mutate(payload);
      }}>
      {({
        touched,
        handleChange,
        errors,
        values,
        setFieldValue,
        setFieldTouched,
        setValues,
        setTouched,
      }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={loading}
            size='sm'
            valueEdited={_.isEqual(values, initialData.data)}
            title={`${modalStatus} SEC Fee`}
            id={id}
            // showToolTip={true}
            // tooltipText={`Permissions allow a company to control its users’ access levels to the module and its fields depending on their roles and functions. Users can have multiple levels of access such as creating and editing a module, to read-only or none at all.`}
            children={
              <Form id="feeModalForm">
                <ModalBody id="feeModalBody">
                  <div className='flex flex-col gap-4' id="feeModalFields">
                    <CustomDatePicker
                      id='effectiveDate'
                      label='Effective Date'
                      name='effectiveDate'
                      onChange={handleChange}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      errors={errors}
                      touched={touched}
                      errorValue={errors?.effectiveDate}
                      touchedValue={touched?.effectiveDate}
                      arrValue={values?.effectiveDate}
                      // values={values}
                      defaultValue={new Date()}
                      fieldLabelName='test'
                      required
                    />
                    <InputText
                      id='rate'
                      type='text'
                      label='Rate ($)'
                      name='rate'
                      onChange={handleChange}
                      onFocus={(e: any) => {
                        values?.rate.replaceAll(',', '');
                      }}
                      onBlur={(e: any) => {
                        CommaFormattedFloatPost(e.target.value, `rate`, setFieldValue);
                        setFieldTouched(`rate`, true);
                      }}
                      errors={errors}
                      touched={touched}
                      required
                    />
                  </div>
                </ModalBody>
                <ModalFooterComponent
                  id='feeModalFooter'
                  modalStatus={modalStatus}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  onEditModal={() => {
                    setModalStatus('Edit');
                  }}
                  valueChanged={_.isEqual(values, initialData.data)}
                  loading={isLoading}
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default FeeModal;
